var _rect, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgScanData(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0",
    transform: "scale(0.0104167)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0",
    width: 96,
    height: 96,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAQAAABIkb+zAAACa0lEQVR42u2ZXU4iQRRGixDf0E0IhBADgvO/AhN34KPuByO6D95ZBy5AWjT8zDjTzyRnHsYQhdKuutXVQ8I9C/jud7Sqmq42RlEURVEURckd1lABFVABFVABFVCBnRSgxY//JUCLVnj9OalEIVyAFnPmQQq0mAOQ8r1ogdVsucIqAuCPr0KYAO1Xs2UKb+r/U/hWlADHa7P9FTbqeyvIBThmsTHbV4EuUwhRkApY68OUru//oMHEEvSbrzEF6FjrT2hIdkGNRK4gEXinfkJNeg4dMrYqfDERoMtPy7QxhyGhdoXn/BWi1H9RSKwKn3Otf2KtnwTXN8YYqjzEVeCEX5YJD1TzGlCznkjPfIpYfyLeutYhdR4tQ+YcBCcfWB6Z8Eg9703W4GltyJLzXJLPWa4lP4nO/cxBzTdP55zqWxSmNE0cOGKWf/01hRlHJh60WeRf/5XCgraJCx1m+dd/UZjRMfEJP3mKT1aUHYQmPe5IcWXfK33fOTfljp7no409+huP9yy8frtQ90xf0mfPvf4Qf069BE4FE4aOClwj4cZL4EY049pt7S9F4WPKzvXL1hdVl4WUvRfoIeXSWeBSPKOXHT4ShydUnOpXrG/Zboyy41PkDChl5pcYBExIswXCuPpYgRJXYQNiC8Dg/YVEJeivX5AAJFxsnkiUuQhY+4UKANxzyxlVKlSocsYt9/kEFyUQDRVQARVQARVQARVQARVQARWIKJBudX+Hl/rRVgs4XKv0tlrA4WJLerVYBEuna3bh5W4RuFzuiq/X4zP0+ULQ37KF5POBY7UX/D4xxULyiUlRFEVRFGVH+Auwn3AMeUFcRAAAAABJRU5ErkJggg=="
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScanData);
export default __webpack_public_path__ + "static/media/ScanData.fe5891f0b2646a82c347c85d9914af81.svg";
export { ForwardRef as ReactComponent };